import { render } from "./AnnotationSetsRadioSelect.vue?vue&type=template&id=16c842a1&scoped=true"
import script from "./AnnotationSetsRadioSelect.vue?vue&type=script&lang=js"
export * from "./AnnotationSetsRadioSelect.vue?vue&type=script&lang=js"

import "./AnnotationSetsRadioSelect.vue?vue&type=style&index=0&id=16c842a1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c842a1"]])

export default __exports__